import { render, staticRenderFns } from "./DialogDetailJudicialProcess.vue?vue&type=template&id=c7e1a4a4"
import script from "./DialogDetailJudicialProcess.vue?vue&type=script&lang=js"
export * from "./DialogDetailJudicialProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports